<template>
  <section class="page-footer__wrap">
    <div class="page-footer__menu footer-menu">
      <FooterNav />
    </div>
    <div class="page-footer__menu page-footer__menu--right footer-menu">
      <FooterPhone />
      <div class="footer-menu__subscribe-form subscribe">
        <span class="footer-menu__subscribe-title">{{ $t('footer_subscribe_title') }}</span>
        <SubscribeForm />
      </div>
    </div>
  </section>
</template>

<script>
import SubscribeForm from './SubscribeForm'
import FooterNav from './FooterNav'
import FooterPhone from './FooterPhone'

export default {
  name: 'FooterMenu',
  components: {
    FooterPhone,
    FooterNav,
    SubscribeForm
  }
}
</script>

<style scoped lang="sass">

.page-footer__menu
  width: 75%

  +mmax(768)
    width: 100%

  &--right
    width: 25%
    min-width: 200px
    margin-left: auto

    +mmax(768)
      display: block
      width: 100%
      margin-left: 0

.footer-menu__subscribe-form
  margin-top: 30px

  +mmax(768)
    margin-top: 40px

.footer-menu__subscribe-title
  font-size: 16px
  font-weight: 500
  color: $white-text-color

  +mmax(768)
    font-size: 18px
</style>
